<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-12 11:06:53
 * @LastEditTime: 2024-03-08 15:00:03
 * @Description:
 * @FilePath: \website\src\pages\home\index.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
    <div>
        <el-carousel class="swiper" height="590px">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <!-- <img width="100%" :src="item" alt="" /> -->
                <el-image :src="item"></el-image>
            </el-carousel-item>
        </el-carousel>
        <!-- 关于我们 -->
        <div class="aboutus">
            <div class="about-text">
                <div class="about-title">
                    中国薯网<br />致力于马铃薯产业物联网建设
                </div>
                <div class="about-content">
                    {{ introduce.content }}
                </div>
                <div class="about-number">
                    <div>
                        <div>100+</div>
                        <div>合作商家</div>
                    </div>
                    <div>
                        <div>30+</div>
                        <div>合作政府</div>
                    </div>
                </div>
                <LoadMore pagename="aboutus"></LoadMore>
            </div>
            <div class="about-img">
                <el-image
                    fit="fill"
                    :src="`http://wwwadm.tudouec.com/profile/resource/www_img/${introduce.image}`"
                ></el-image>
            </div>
        </div>
        <!-- 行业资讯 -->
        <div class="news topic">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/news-index.png"
                :showMore="true"
                pagename="news"
            ></Topic>
            <div class="list">
                <template v-for="(item, index) in news">
                    <div
                        class="list-item-img"
                        :key="index"
                        v-if="index == 0"
                        @click="$router.push({ name: 'content', params: item })"
                    >
                        <el-image :src="item.cover"></el-image>
                        <div class="text">
                            <div class="date">
                                <div class="days">
                                    {{ item.newsDate.split("-")[2] }}
                                </div>
                                <div class="mouth">
                                    {{ item.newsDate.split("-")[0] }}-{{
                                        item.newsDate.split("-")[1]
                                    }}
                                </div>
                            </div>
                            <div class="title">{{ item.title }}</div>
                        </div>
                    </div>
                    <div
                        class="list-item"
                        :key="index"
                        v-if="index > 0"
                        @click="$router.push({ name: 'content', params: item })"
                    >
                        <div class="date">
                            <div class="days">
                                {{ item.newsDate.split("-")[2] }}
                            </div>
                            <div class="mouth">
                                {{ item.newsDate.split("-")[0] }}-{{
                                    item.newsDate.split("-")[1]
                                }}
                            </div>
                        </div>
                        <div class="title">{{ item.title }}</div>
                        <div class="content">{{ item.subtitle }}</div>
                        <div class="arrow">
                            <i class="el-icon-right"></i>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!-- 数据可视 -->
        <div class="visualizations topic">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/visualizations-topic-index.png"
                :showMore="true"
                color="#FFF"
                arrowColor="#FFF"
                pagename="quotation"
            ></Topic>
            <el-row :gutter="32">
                <el-col :span="12">
                    <div class="title">今日均价</div>
                    <el-row :gutter="12">
                        <el-col
                            :span="8"
                            v-for="(item, index) in visualizations"
                            :key="index"
                        >
                            <el-row
                                class="price-tag"
                                type="flex"
                                align="middle"
                            >
                                <el-col :span="14">
                                    <div class="province">
                                        {{ item.area_name }}
                                    </div>
                                    <div class="price">
                                        {{ item.avg_price.toFixed(2) }}元/公斤
                                    </div>
                                </el-col>
                                <el-col :span="10" style="text-align: right">
                                    <img
                                        width="40"
                                        src="http://wwwadm.tudouec.com/profile/resource/www_img/icon-money.png"
                                        alt=""
                                    />
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-pagination
                        background
                        hide-on-single-page
                        layout="prev, next"
                        :page-size="pageSize"
                        :total="visualizationsTotal"
                        @prev-click="
                            (e) => {
                                pageNum = e;
                            }
                        "
                        @next-click="
                            (e) => {
                                pageNum = e;
                            }
                        "
                    ></el-pagination>
                </el-col>
                <el-col :span="12">
                    <div class="filter">
                        <div class="title">价格走势</div>
                        <el-select
                            v-model="queryChart.areaId"
                            placeholder="请选择"
                            size="mini"
                            ><el-option key="" label="全国" value="">
                            </el-option>
                            <el-option
                                v-for="item in areaOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>

                    <div
                        id="eChart"
                        :style="{ width: '588px', height: '238px' }"
                    ></div>
                    <div class="granularity">
                        <div class="tab-date">
                            <div
                                :class="{ active: curType == 'year' }"
                                @click="changeQuery('year', 'cur')"
                            >
                                年度
                            </div>
                            <div
                                :class="{ active: curType == 'mouth' }"
                                @click="changeQuery('mouth', 'cur')"
                            >
                                月度
                            </div>
                        </div>
                        <div class="tab-date" v-if="curType == 'mouth'">
                            <div
                                :class="{ active: curDate == 'prev' }"
                                @click="changeQuery(curType, 'prev')"
                            >
                                上月
                            </div>
                            <div
                                :class="{ active: curDate == 'cur' }"
                                @click="changeQuery(curType, 'cur')"
                            >
                                本月
                            </div>
                        </div>
                        <div class="tab-date" v-if="curType == 'year'">
                            <div
                                :class="{ active: curDate == 'prev' }"
                                @click="changeQuery(curType, 'prev')"
                            >
                                去年
                            </div>
                            <div
                                :class="{ active: curDate == 'cur' }"
                                @click="changeQuery(curType, 'cur')"
                            >
                                今年
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 合作商家 -->
        <div class="cooperator">
            <img
                width="100%"
                src="http://wwwadm.tudouec.com/profile/resource/www_img/cooperator-index.png"
                alt=""
            />
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
export default {
    data() {
        return {
            bannerList: [
                "http://wwwadm.tudouec.com/profile/resource/www_img/banner-index.png",
            ],
            introduce: {
                image: "about-index.png",
            },
            news: [],
            visualizations: null,
            visualizationsTotal: 0,
            pageNum: 1,
            pageSize: 6,
            areaOptions: [],
            chartOption: {
                color: ["#FFFFFF"],
                xAxis: {
                    type: "category",
                    axisLine: {
                        lineStyle: {
                            color: "#FFF",
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#FFF",
                        },
                    },
                    data: [],
                },
                yAxis: {
                    color: "#FFFFFF",
                    name: "单位：元",
                    axisLine: {
                        lineStyle: {
                            color: "#FFF",
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#FFF",
                        },
                    },
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    showContent: true, // 是否显示提示框浮层，默认显示
                    alwaysShowContent: true, // 是否永远显示提示框内容，默认情况下在移出可触发提示框区域后一定时间后隐藏
                    triggerOn: "mousemove|click", // 提示框触发的条件（'mousemove'，鼠标移动时触发；'click'，鼠标点击时触发；'mousemove|click'，同时鼠标移动和点击时触发；'none'，不在 'mousemove' 或 'click' 时触发）
                    confine: true, // 是否将 tooltip 框限制在图表的区域内
                    backgroundColor: "rgba(50,50,50,0.7)", // 提示框浮层的背景颜色
                    padding: 5, // 提示框浮层内边距，单位px
                    textStyle: {
                        color: "#FFF", // 文字的颜色
                        fontStyle: "normal",
                        fontWeight: "normal",
                        fontSize: "16", // 文字字体大小
                    },
                    formatter: function (params) {
                        var result = "";
                        result +=
                            params[0].axisValue +
                            "</br>" +
                            "最高价:" +
                            (params[1].data + params[0].data).toFixed(2) +
                            "</br>" +
                            "平均价:" +
                            params[2].data.toFixed(2) +
                            "</br>" +
                            "最低价:" +
                            params[0].value.toFixed(2);
                        return result;
                    },
                },
                series: [
                    {
                        name: "L",
                        type: "line",
                        data: [],
                        lineStyle: {
                            // opacity: 0.5,
                        },
                        stack: "confidence-band",
                        symbol: "none",
                    },
                    {
                        name: "U",
                        type: "line",
                        data: [],
                        lineStyle: {
                            // opacity: 0.5,
                        },
                        areaStyle: {
                            color: "#ccc",
                        },
                        stack: "confidence-band",
                        symbol: "none",
                    },
                    {
                        type: "line",
                        data: [],
                        itemStyle: {
                            color: "#FFF",
                        },
                    },
                ],
            },
            chart: null,
            queryChart: {
                areaId: null,
                year: new Date().getFullYear(),
                mouth: new Date().getMonth() + 1,
            },
            curType: "mouth",
            curDate: "cur",
        };
    },
    mounted() {
        this.$api.getIntroduceJson("index").then((res) => {
            this.introduce = res.introduce;
        });
        this.getNewsList("dynamics");
        this.getPriceDataView();
        this.getRootArea();
        this.queryChart.areaId = "";
        this.chart = echarts.init(document.getElementById("eChart"));
    },
    watch: {
        queryChart: {
            handler: function (newVal) {
                // console.log(newVal)
                this.getPriceTendency();
            },
            deep: true,
        },
        pageNum() {
            this.getPriceDataView();
        },
    },
    methods: {
        // 获取行业资讯
        getNewsList(type) {
            const that = this;
            let reqData = {
                type: type,
                isAsc: "desc",
                orderByColumn: "newsDate",
            };
            that.$api.getNewsList(reqData).then((res) => {
                that.news = res.rows;
            });
        },
        // 获取可视数据
        getPriceDataView() {
            const that = this;
            let req = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            };
            that.$api.getPriceDataView(req).then((res) => {
                that.visualizations = res.rows;
                that.visualizationsTotal = res.total;
            });
        },
        // 查询价格走势区域
        getRootArea() {
            const that = this;
            that.$api.getRootArea().then((res) => {
                that.areaOptions = res.data;
                // that.queryChart.areaId = res.data[0].id;
            });
        },
        // 获取价格走势图表数据
        getPriceTendency() {
            const that = this;
            let req = that.queryChart;
            that.chartOption = that.$options.data().chartOption;
            that.$api.getPriceTendency(req).then((res) => {
                res.data.map((item) => {
                    that.chartOption.xAxis.data.push(item.price_date);
                    that.chartOption.series[0].data.push(item.min_price);
                    that.chartOption.series[1].data.push(
                        item.max_price - item.min_price
                    );
                    that.chartOption.series[2].data.push(item.avg_price);
                });
                // let max = Math.max.apply(null, that.chartOption.series[1].data)
                that.chart.setOption(that.chartOption);
            });
        },
        changeQuery(type = "", date = "") {
            this.curType = type == "" ? this.curType : type;
            this.curDate = date == "" ? this.curDate : date;
            const year = new Date().getFullYear();
            const mouth = new Date().getMonth() + 1;
            if (type == "year") {
                this.queryChart.mouth = "";
                this.queryChart.year = date == "prev" ? year - 1 : year;
            }
            if (type == "mouth") {
                this.queryChart.year = year;
                this.queryChart.mouth = date == "prev" ? mouth - 1 : mouth;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.swiper {
    .el-carousel__indicators--horizontal {
        left: 360px;
        bottom: 30%;
    }
}
.aboutus {
    width: 1200px;
    height: 448px;
    background: #ffffff;
    border-radius: 6px;
    margin: -160px auto 64px;
    z-index: 15;
    position: relative;
    display: flex;
    .about-text {
        flex: 1;
        padding: 56px 48px;
        .about-title {
            font-size: $font-size-xl;
            color: $color-title;
            font-weight: 600;
        }
        .about-content {
            width: 348px;
            height: 76px;
            margin-top: 24px;
            color: $color-content;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        }
        .about-number {
            display: flex;
            margin: 40px 0 56px;
            & > div {
                width: 142px;
                :first-child {
                    font-size: 32px;
                    color: $color-title;
                    font-family: DIN-Bold, DIN;
                    font-weight: bold;
                }
                :last-child {
                    font-size: $font-size-s;
                    color: $color-content;
                }
            }
        }
    }
    .about-img {
        flex-basis: 609px;
    }
}
.news {
    margin-bottom: 64px;
    .list {
        display: flex;
        height: 306px;
        .days {
            font-size: 32px;
            line-height: 32px;
            font-weight: bold;
        }
        .mouth {
            font-size: $font-size-s;
        }
        .title {
            color: $color-title;
            font-size: $font-size-m;
            font-weight: 600;
        }
        .list-item {
            margin-left: 24px;
            padding: 32px 24px;
            border-radius: 4px;
            border: 1px solid #dddddd;
            .days {
                color: $color-main;
            }
            .title {
                margin: 24px 0 16px;
            }
            .arrow {
                margin-top: 28px;
            }
            &:hover {
                background-color: $color-main;
                transform: translateY(-20px);
                * {
                    color: #ffffff !important;
                }
            }
        }
        .list-item-img {
            background-color: #ffffff;
            border-radius: 4px;
            img,
            .el-image {
                width: 458px;
                height: 250px;
                display: block;
            }
            .text {
                display: flex;
                align-items: center;
            }
            .title {
                padding: 16px;
            }
            .date {
                width: 56px;
                height: 56px;
                background-color: $color-main;
                text-align: center;
                padding: 5px 0;
                .days,
                .mouth {
                    color: #ffffff;
                }
            }
        }
    }
}
/deep/.visualizations {
    padding-top: 40px;
    background-color: $color-main;
    background-image: url("http://wwwadm.tudouec.com/profile/resource/www_img/visualizations-index.png");
    background-size: cover;
    height: 480px;
    margin-bottom: 64px;
    position: relative;
    .title {
        color: #ffffff;
        font-size: $font-size-m;
        margin-bottom: 20px;
        font-weight: 600;
    }
    .price-tag {
        width: 188px;
        height: 91px;
        background: #ffffff;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 12px;
        cursor: pointer;
        .province {
            font-weight: 600;
            color: $color-title;
        }
        .price {
            font-size: $font-size-m;
            font-weight: 600;
            color: $color-title;
        }
        .date {
            font-size: $font-size-s;
        }
    }
    .el-pagination {
        position: absolute;
        bottom: 0;
    }

    .filter {
        display: flex;
        justify-content: space-between;
        .el-input__inner {
            background-color: rgba(0, 0, 0, 0.2);
            color: #fff;
        }
        .el-range-editor.is-active,
        .el-range-editor.is-active:hover,
        .el-select
            .el-input__inner:focus，
            .el-select
            .el-input.is-focus
            .el-input__inner {
            border-color: #ffffff;
        }
    }
    .granularity {
        display: flex;
        justify-content: space-around;
        color: #fff;
        margin-top: -28px;
        z-index: 9;
        position: relative;

        .tab-date {
            display: flex;
            justify-content: space-between;
            div {
                margin: 0 10px;
                cursor: pointer;
            }

            .active {
                font-weight: 600;
                border-bottom: #fff solid 2px;
            }
        }
    }
}
.cooperator {
    padding-bottom: 88px;
}

/deep/.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select.el-input__inner:focus，
    .el-select.el-input.is-focus.el-input__inner {
    border-color: #ffffff;
}
.el-select-dropdown__item.selected {
    color: $color-main;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue